module.exports = __webpack_public_path__ + "img/ZG81_11.0cf1b7df.jpg";